import { ref, computed } from 'vue';
import { getAllPlaces, searchPlaces } from '@/services/places.service';
export function usePlaces(initial = {}) {
    const all = ref(getAllPlaces());
    const query = ref(initial.query || '');
    const region = ref(initial.region || '');
    const categoria = ref(initial.categoria || '');
    const ciudad = ref(initial.ciudad || '');
    const tipo = ref(initial.tipo || '');
    const resultados = computed(() => {
        return searchPlaces({
            query: query.value,
            region: region.value,
            categoria: categoria.value,
            ciudad: ciudad.value,
            tipo: tipo.value
        });
    });
    const regionesDisponibles = computed(() => {
        const set = new Set(all.value.map(p => p.region));
        return Array.from(set);
    });
    function resetFilters() {
        query.value = '';
        region.value = '';
        categoria.value = '';
        ciudad.value = '';
        tipo.value = '';
    }
    return {
        all,
        query,
        region,
        categoria,
        ciudad,
        tipo,
        resultados,
        regionesDisponibles,
        resetFilters
    };
}
